/**
 * Night (1.05, one of the skies: see `SkyName` in utils/mapWeather.ts): the map is dim, a moonlit blue (1.05.2: the
 * page's `DARK_ALPHA`), and every player carries a flashlight, on as they come in. The middle mouse button turns it off
 * and on (a key can be chosen for it as well: V, the owner's other choice, is the Gravity Gloves' merge already). Its
 * beam lights the ground in front of its player for everyone; with it off the way ahead stays dim. There's no line of
 * sight: a beam isn't stopped by walls and nothing is greyed out (the owner, 28 October 2026: "no line of sight shit").
 *
 * The dark hides no player (1.05.1, the owner, the same day: "Players should show in the dark regardless"): every
 * player shows, their flashlight on or off, and the server sends whoever a screen would show by day
 * (`Player._canSee`); the practice bots see as they do by day. 1.05.1 drew each in a glow of their own, which lit the
 * ground round them; 0.98.1 takes the dark off their bodies only (`body`; the owner, 30 October 2026: "there should be
 * no light that automaticallysurrounds players like it does now"), so the way round you is lit by your flashlight, a
 * fire, a blast or a street light, or not at all.
 *
 * Shared by the server (the flashlight's switch) and the page (the beams, the glows, the flashes). Distances are game
 * units (the default 2x view reaches 100 units from the middle of the screen to its far side).
 */
export const Night = Object.freeze({
    /** how far a flashlight's beam reaches from its player */
    reach: 85,
    /** half the beam's width (radians: about 23 degrees each side) */
    halfAngle: 0.4,
    /**
     * the dark taken off every player's body, this far from their middle (0.98.1; a player is 2.25 round): each is seen
     * in the dark, and nothing round them is lit. (1.05.1's glow round every player, 7, lit the few steps round them)
     */
    body: 2.6,
    /** how far round a burning patch its light falls */
    fireLight: 12,
    /** an explosion's flash: how far round it it lights (its largest radius times `scale`, `min` at least), how long (ms) */
    blast: Object.freeze({ scale: 1.6, min: 12, ms: 500 }),
    /** the shortest time between two switches of a player's flashlight (ms: a page can't make it flicker) */
    toggleMs: 150
});
